// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"8":"editor","171":"collection","275":"article","445":"start","685":"preview","766":"statistics","914":"preload"}[chunkId] || chunkId) + "." + {"8":"8389a32e","171":"5adf0eed","275":"5adf0eed","386":"31d6cfe0","445":"5adf0eed","685":"5adf0eed","766":"5adf0eed","914":"d9b4fd69"}[chunkId] + ".chunk.css";
};